import React, { useState, useEffect } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from './../../firebase/firebaseConfig';
import PageTitle from '../includes/PageTitle';
import Layout from './Layout';
import { Link } from 'react-router-dom';

const AllProduct = () => {
  const [productList, setProductList] = useState([]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const productsCollection = collection(db, 'Products');
        const productsSnapshot = await getDocs(productsCollection);
        const products = productsSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
          image: doc.data().images[0] // Assuming the first image is the main image
        }));
        setProductList(products);
      } catch (error) {
        console.error("Error fetching products: ", error);
      }
    };

    fetchProducts();
  }, []);

  return (
    <>
      <PageTitle title="All Products - ALMOSTINVISIBLE" />
      <Layout>
        <div className="mt-5">
          <h1 className='unbounded'>All Products</h1>
          <div className='table-responsive'>
            <table className="table table-striped table-bordered">
              <thead className="thead-dark">
                <tr>
                  <th></th>
                  <th>Name</th>
                  <th>Product ID</th>
                  <th>Total Stock</th>
                  <th>Sold</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {productList.map((product) => (
                  <tr key={product.id} style={{height: "10vh", margin: "1vh auto", verticalAlign: "middle"}}>
                    <td><img src={product.image} alt={product.name} className="img-fluid" width="100" /></td>
                    <td>{product.name}</td>
                    <td>{product.id}</td>
                    <td>{product.quantity}</td>
                    <td>{product.sold}</td>
                    <td>
                      <Link to={`/a/edit-product/${product.id}`} style={{fontSize: "10px"}} className='black-button'>
                        View/Edit full details
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default AllProduct;
